import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';

@i18n
class SubscriptionSplashBox extends Component {
  render() {
    const { onClick, offer } = this.props;

    return (
      <Row>
        <Col sm={6}>
          <div className="pricing" onClick={onClick}>
            <div className="planname">{offer.label}</div>
            <div className="price">
              <span className="per">kun&nbsp;</span>
              {offer.amount}
              <span className="per">{`,- kr. i ${offer.trialDays} dag${
                offer.trialDays > 1 ? 'e' : ''
              }`}</span>
            </div>
            <div className="billing">
              {`Herefter ${offer.price}`}
              <br />i løbende abonnement
            </div>
          </div>
          <small>
            Introprisen på {offer.amount} kr. dækker abonnementets første{' '}
            {offer.trialDays} dage. Abonnementet fortsætter herefter automatisk
            til {offer.recurring[0]} kr. Introperioden kan kun købes én gang.
          </small>
          <br />
          <br />
        </Col>
        <Col sm={6}>
          <div className="panel panel-info">
            <div className="panel-heading">
              <h3 className="text-center" style={{ margin: 0 }}>
                Dine fordele
              </h3>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <i className="fa fa-check" /> Kontakt til alle udlejere
              </li>
              <li className="list-group-item">
                <i className="fa fa-check" /> Først besked om nye boliger
              </li>
              <li className="list-group-item">
                <i className="fa fa-check" /> Automatisk fornyelse
                {/* <span style={{ display: 'none', color: 'grey', marginLeft: '18px' }} >Efter 3 dage fornyes abonnementet hver 30. dag</span>*/}
              </li>
              <li className="list-group-item">
                <i className="fa fa-check" /> Hurtig og nem afmelding
              </li>
            </ul>
            <div className="panel-footer">
              <a className="btn btn-lg btn-block btn-success" onClick={onClick}>
                Opret boligsøgerannonce »
              </a>
            </div>
          </div>
          Efter betaling sender vi dig tilbage til den bolig, du er interesseret
          i.
        </Col>
      </Row>
    );
  }
}

export default SubscriptionSplashBox;
